export const getStyles = () => {
    const styles = {
        progress: {
            position: 'relative', 
            height: '300px'
        }
    };
    return styles;
};